
(() => {
  if (!customElements.get('fl-home-carousel')) {
    class FlHomeCarousel extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.track = this.querySelector('[data-fl-track]');
        if (!this.track) return;
        this.buttons = [...this.closest('.fl-products').querySelectorAll('[aria-controls]')].filter(button => button.getAttribute('aria-controls') === this.track.id);
        this.buttons.forEach(button => button.addEventListener('click', () => {
          const card = this.track.querySelector('.fl-product');
          if (!card) return;
          const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
          const step = (card.getBoundingClientRect().width + gap) * 2;
          const dir = button.hasAttribute('data-fl-prev') ? -1 : 1;
          this.track.scrollBy({left: dir * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        }, {signal}));
        this.track.addEventListener('scroll', () => this.updateButtons(), {passive:true, signal});
        this.resizeObserver = new ResizeObserver(() => this.updateButtons());
        this.resizeObserver.observe(this.track);
        this.updateButtons();
      }
      updateButtons() {
        const end = this.track.scrollWidth - this.track.clientWidth;
        this.buttons.forEach(button => {
          button.disabled = button.hasAttribute('data-fl-prev') ? this.track.scrollLeft <= 2 : this.track.scrollLeft >= end - 2;
        });
      }
      disconnectedCallback() { this.controller?.abort(); this.resizeObserver?.disconnect(); }
    }
    customElements.define('fl-home-carousel', FlHomeCarousel);
  }
  // Delegation also covers section replacements in Shopify's editor.
  if (!window.flaconiaHomeMenuBound) {
    window.flaconiaHomeMenuBound = true;
    document.addEventListener('click', event => {
      const menu = event.target.closest('.fl-mobile-menu');
      if (menu && event.target.closest('a')) menu.open = false;
      if (!menu) document.querySelectorAll('.fl-mobile-menu[open]').forEach(el => el.open = false);
    });
    document.addEventListener('keydown', event => {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('.fl-mobile-menu[open]').forEach(menu => {menu.open = false;menu.querySelector('summary')?.focus();});
    });
  }
})();
